import { render } from "./consultation_at_radiology.vue?vue&type=template&id=68fad797&scoped=true"
import script from "./consultation_at_radiology.vue?vue&type=script&lang=js"
export * from "./consultation_at_radiology.vue?vue&type=script&lang=js"

import "./consultation_at_radiology.vue?vue&type=style&index=0&id=68fad797&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68fad797"]])

export default __exports__